import React from 'react';
import Package from './Package';
import styled from 'styled-components';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from 'antd'

const HeadingItem = styled.div`
  padding-left: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #a7a7a7;
  @media screen and (max-width: 600px) {
    padding-left: 10px;
  }
  display: flex;
  algin-items: center;
  svg {
    font-size: 20px;
    color: #f2a603;
  }
`;

const StyledBox = styled.div`
  background: var(--card-color);
  border: 1px solid rgb(0 0 0 / 8%);
  border-radius: 16px;
  box-shadow: rgb(14 30 37 / 12%) 0px 2px 4px 0px, rgb(14 30 37 / 32%) 0px 2px 16px 0px;
  overflow: hidden;
`

const StyledWrapHeading = styled.div`
  display: flex;
  padding: 10px 30px;
  justify-content: space-between;
  @media screen and (max-width: 600px) {
    display: none;
  }
`

export default function Staking({packageWithData, rootUrlsView, fetchDetailPool, fetchTotalValue}) {
  return (
    <div>
      <StyledWrapHeading>
        <HeadingItem style={{flex: 1}}>Package</HeadingItem>
        <HeadingItem style={{flex: 2}}>APR&nbsp;
        <Tooltip title={<div>APR is fixed in your whole staking period, but will decline 5% of its last month absolute rate for newcomers. <a href="https://bit.ly/3uTZzMU" target="_blank" rel="noreferrer">Details</a></div>}>
          <InfoIcon />
        </Tooltip>
        </HeadingItem>
        <HeadingItem style={{flex: 4}}>DURATION</HeadingItem>
        <HeadingItem style={{flex: 1}}>
          TYPE
        </HeadingItem>
        <HeadingItem style={{flex: 2}}>
          RANGE AMOUNT
        </HeadingItem>
        <HeadingItem style={{flex: 1}}></HeadingItem>
      </StyledWrapHeading>

      <StyledBox>
        {packageWithData.map((item, index) => {
          return <Package key={index} item={item} rootUrlsView={rootUrlsView} fetchDetailPool={fetchDetailPool} fetchTotalValue={fetchTotalValue} />;
        })}
      </StyledBox>
    </div>
  );
}
